var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pokemon-progress-bar",class:_vm.variant === 'evolve' ? 'bar-evolve-track' : 'bar-level-track',style:({height: _vm.height + 'px'})},[_c('div',{staticClass:"pokemon-progress-bar-fill",class:[
            _vm.variant === 'evolve' ? 'bar-evolve-fill' : 'bar-level-fill',
            {'pokemon-progress-bar-fill--pulse': _vm.percent >= _vm.pulseThreshold},
        ],style:({width: _vm.percent + '%'})}),(_vm.percent > 0 && _vm.percent < 100)?_c('div',{staticClass:"pokemon-progress-bar-seam",style:({left: _vm.percent + '%'})}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }